require('smartbanner.js');
